import React, { useState } from "react";
import localFooterImg from "../../../../assets/image/Subscribe_image.png";
import subscribeImg from "../../../../assets/image/1Asset 306@4x.png";
import sunscribeLion from "../../../../assets/image/lion-walking.png";
import { errorMessage, successMessage } from "../../Util/Toaster"; // Uncomment when using toaster
import { AddSubscription } from "../../../../api/leads"; // Uncomment when using API
import { formatUSPhoneNumber } from "../../../../util/stringformat";

export default function SubscribeNow() {
  // Defined type for errors
  type FormErrors = {
    firstName?: string;
    lastName?: string;
    addressLine1?: string;
    // addressLine2?: string;
    city?: string;
    state?: string;
    zipCode?: string;
    // country?: string;
    phone?: string;
    emailAddress?: string;

  };

  const initialUserDetails = {
    firstName: "",
    lastName: "",
    addressLine1: "",
    // addressLine2: "",
    city: "",
    state: "",
    zipCode: "",
    // country: "",
    phone: "",
    emailAddress: "",

  };

  const [userDetails, setUserDetails] = useState(initialUserDetails);
  const [errors, setErrors] = useState<FormErrors>({});

  const validate = (name, value) => {
    let errorMsg = "";

    const isEmpty = (str) => !str || !str.trim();
    const isAlpha = (str) => /^[a-zA-Z\s]+$/.test(str);
    const isAlphanumeric = (str) => /^[a-zA-Z0-9\s]+$/.test(str);
    const isEmail = (str) =>
      /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(str);
    const isPhone = (str) => {
      if (str.length > 15) return false; // Increased slightly for intl codes
      const validChars = /^[\d\s()+-]*$/;
      if (!validChars.test(str)) return false;
      return true;
    };

    // 1. Skip "Required" check for optional fields
    if (name === "addressLine2" && isEmpty(value)) {
      return "";
    }

    // 2. Global Required Check
    if (isEmpty(value)) {
      errorMsg = "This field is required";
      return errorMsg;
    }

    // 3. Specific Formatting Checks
    switch (name) {
      case "firstName":
      case "lastName":
        if (!isAlpha(value)) {
          errorMsg = "Can only contain letters and spaces";
        } else if (value.length < 2) {
          errorMsg = "Must be at least 2 characters";
        } else if (value.length > 25) {
          errorMsg = "Cannot exceed 25 characters";
        }
        break;

      case "addressLine1":
      // case "addressLine2": // Added case here to allow alphanumeric check if not empty
      case "city":
      case "state":
        // case "country":
        if (!isAlphanumeric(value)) {
          errorMsg = "Can only contain letters, numbers, and spaces";
        } else if (value.length < 2) {
          errorMsg = "Must be at least 2 characters";
        } else if (value.length > 50) {
          errorMsg = "Cannot exceed 50 characters";
        }
        break;

      case "zipCode":
        // Basic US Zip regex, adjust if international
        if (!/^\d{5}(-\d{4})?$/.test(value) && !/^[A-Za-z0-9\s-]{3,10}$/.test(value)) {
          // The second regex is a broader catch-all for international codes if needed
          errorMsg = "Invalid zip code format";
        }
        break;

      case "phone":
        if (!isPhone(value)) {
          errorMsg = "Phone number contains invalid characters";
        }
        break;

      case "emailAddress":
        if (!isEmail(value)) {
          errorMsg = "Invalid email format";
        }
        break;

      default:
        break;
    }

    return errorMsg;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(userDetails)
    setUserDetails((prev) => ({ ...prev, [name]: value }));

    // Real-time validation
    const errorMsg = validate(name, value);
    setErrors((prev) => ({ ...prev, [name]: errorMsg }));
  };

  const handleSubmit = async (e, formType) => {
    e.preventDefault();
    let formValid = true;
    const newErrors = {};

    // Validate all fields
    for (const key in userDetails) {
      const err = validate(key, userDetails[key]);
      if (err) {
        formValid = false;
        newErrors[key] = err;
      }
    }

    setErrors(newErrors);

    if (formValid) {
      console.log("Form is valid, submitting:", userDetails);

      // Uncomment below to enable API submission

      try {
        const response = await AddSubscription(userDetails);
        if (response.data > 0) { // Adjust based on actual API response structure
          successMessage("Form Submitted successfully");
          setUserDetails(initialUserDetails);
        } else {
          errorMessage("An error occurred during submission.");
        }
      } catch (error) {
        console.error("Submission error:", error);
        errorMessage("An error occurred during submission.");
      }

    } else {
      console.log("Form has errors");
    }
  };

  return (
    <div className="sub-now-container">
      <div className="container">
        <div className="quiz-section home-page-banner-section local-footer-section">
          <div className="container-fluid">
            <div className="row justify-content-end">
              <div className="col-12 col-md-12 col-lg-5 subscribe-section">
                <p className="milford-inside">Become a Milford Insider</p>
                <h1 className="subscribe-heading">Subscribe</h1>
                <h1 className="subscribe-heading">Now!</h1>
                <h6 className="subscribe-inner-heading">
                  Experience Milford Magazine
                </h6>
                <p className="subscribe-para">
                  Get our beautifully designed, <b> complimentary </b>
                  publication, packed with rich stories and exclusive insights,
                  delivered right to your home.
                </p>
                <img
                  src={subscribeImg}
                  className="subscribeImg"
                  alt="subscribe Image"
                />
                <img
                  src={sunscribeLion}
                  className="subscribe-lion"
                  alt="lion walking"
                />
              </div>
              <div className="col-12 col-md-12 col-lg-7">
                <form onSubmit={(e) => handleSubmit(e, "subscribe")} className="quize-form-section">
                  <div className="row justify-content-center">

                    {/* First Name */}
                    <div className="col-12 col-md-6 mb-4">
                      <input
                        type="text"
                        className="w-100 quiz-input"
                        placeholder="First Name*"
                        name="firstName"  // FIXED
                        value={userDetails.firstName}
                        onChange={handleChange}
                      />
                      {errors.firstName && (
                        <small className="text-danger">{errors.firstName}</small>
                      )}
                    </div>

                    {/* Last Name */}
                    <div className="col-12 col-md-6 mb-4">
                      <input
                        type="text"
                        className="w-100 quiz-input"
                        placeholder="Last Name*"
                        name="lastName" // FIXED
                        value={userDetails.lastName}
                        onChange={handleChange}
                      />
                      {errors.lastName && (
                        <small className="text-danger">{errors.lastName}</small>
                      )}
                    </div>

                    {/* Address Line 1 */}
                    <div className="col-12 col-md-6 mb-4">
                      <input
                        type="text"
                        className="w-100 quiz-input"
                        placeholder="Address*"
                        name="addressLine1" // FIXED
                        value={userDetails.addressLine1}
                        onChange={handleChange}
                      />
                      {errors.addressLine1 && (
                        <small className="text-danger">{errors.addressLine1}</small>
                      )}
                    </div>

                    {/* Address Line 2 */}
                    {/* <div className="col-12 col-md-6 mb-4">
                    <input
                      type="text"
                      className="w-100 quiz-input"
                      placeholder="Address Line 2"
                      name="addressLine2" // FIXED
                      value={userDetails.addressLine2}
                      onChange={handleChange}
                    />
                    {errors.addressLine2 && (
                      <small className="text-danger">{errors.addressLine2}</small>
                    )}
                  </div> */}

                    {/* City */}
                    <div className="col-12 col-md-6 mb-4">
                      <input
                        type="text"
                        className="w-100 quiz-input"
                        placeholder="City*"
                        name="city"
                        value={userDetails.city}
                        onChange={handleChange}
                      />
                      {errors.city && (
                        <small className="text-danger">{errors.city}</small>
                      )}
                    </div>

                    {/* State */}
                    <div className="col-12 col-md-6 mb-4">
                      <input
                        type="text"
                        className="w-100 quiz-input"
                        placeholder="State*"
                        name="state"
                        value={userDetails.state}
                        onChange={handleChange}
                      />
                      {errors.state && (
                        <small className="text-danger">{errors.state}</small>
                      )}
                    </div>

                    {/* Zip Code */}
                    <div className="col-12 col-md-6 mb-4">
                      <input
                        type="text"
                        className="w-100 quiz-input"
                        placeholder="Zip Code*"
                        name="zipCode" // FIXED
                        value={userDetails.zipCode}
                        onChange={handleChange}
                      />
                      {errors.zipCode && (
                        <small className="text-danger">{errors.zipCode}</small>
                      )}
                    </div>

                    {/* Country */}
                    {/* <div className="col-12 col-md-6 mb-4">
                    <input
                      type="text"
                      className="w-100 quiz-input"
                      placeholder="Country*"
                      name="country"
                      value={userDetails.country}
                      onChange={handleChange}
                    />
                    {errors.country && (
                      <small className="text-danger">{errors.country}</small>
                    )}
                  </div> */}

                    {/* Phone */}
                    <div className="col-12 col-md-6 mb-4">
                      <input
                        type="text"
                        className="w-100 quiz-input"
                        placeholder="Phone"
                        name="phone"
                        value={formatUSPhoneNumber(userDetails.phone)}
                        onChange={handleChange}
                      />
                      {errors.phone && (
                        <small className="text-danger">{errors.phone}</small>
                      )}
                    </div>

                    {/* Email */}
                    <div className="col-12 col-md-6 mb-4">
                      <input
                        type="email"
                        className="w-100 quiz-input"
                        placeholder="Email Address"
                        name="emailAddress" // FIXED
                        value={userDetails.emailAddress}
                        onChange={handleChange}
                      />
                      {errors.emailAddress && (
                        <small className="text-danger">{errors.emailAddress}</small>
                      )}
                    </div>

                    <div>
                      <button className="quiz-btn submit-btn">SUBMIT</button>
                    </div>
                  </div >
                </form >
              </div >
            </div >
          </div >
        </div >
      </div >
    </div>
  );
}